import React, { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Camera, Image as ImageIcon, X } from "lucide-react";
import { toast } from "sonner";

/**
 * PhotoUpload: click to snap or pick a photo → uploads to /api/uploads → returns URL.
 * value = photo_url (string) or null. onChange(url|null).
 */
export default function PhotoUpload({ value, onChange, kind = "attachment", label = "Foto" }) {
  const fileRef = useRef();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", kind);
    try {
      const { data } = await api.post(`/uploads?kind=${encodeURIComponent(kind)}`, fd);
      onChange(data.photo_url);
      toast.success("Foto terupload");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Upload gagal");
    } finally { setBusy(false); e.target.value = ""; }
  };

  const src = value ? `${process.env.REACT_APP_BACKEND_URL}${value}?auth=${localStorage.getItem("erp_token") || ""}` : null;

  return (
    <div>
      <div className="text-xs font-mono uppercase text-neutral-400 mb-1">{label}</div>
      {!value ? (
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={busy}
          data-testid={`upload-${kind}-btn`}
          className="w-full h-24 border border-dashed border-neutral-700 hover:border-[#FF6600] text-neutral-500 hover:text-[#FF6600] flex items-center justify-center gap-2 text-sm font-mono no-transition-all"
          style={{ transition: "border-color 0.15s, color 0.15s" }}
        >
          <Camera size={18} /> {busy ? "MENGUPLOAD..." : "AMBIL / PILIH FOTO"}
        </button>
      ) : (
        <div className="relative border border-neutral-800">
          <img src={src} alt="preview" className="w-full h-32 object-cover" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute top-1 right-1 w-6 h-6 bg-black/70 hover:bg-[#DC2626] flex items-center justify-center"
            data-testid={`remove-${kind}-btn`}
          >
            <X size={14} />
          </button>
        </div>
      )}
      <input ref={fileRef} type="file" accept="image/*" capture="environment" hidden onChange={onFile} />
    </div>
  );
}
